import axios from "axios";
import type { RcFile } from "rc-upload/lib/interface";
import { Result } from "./types";
import { publicAxiosInstance } from "@/axiosInstance";

const generatePresignedUrl = async ({ file_name }: { file_name: string }) => {
  const { data } = await axios.post<Result>(`/data/generate_presigned_url?file_name=${file_name}`);

  for (let i = 0; i < data.result.length; i++) {
    data.result[i].key = i;
  }

  const url = data?.result?.url as string;
  const key = data?.result?.key as string;

  return { url, key };
};

const uploadToS3 = async ({ url, file }: { url: string; file: RcFile }) => {
  const { data } = await publicAxiosInstance.put(url, file, {});

  return data;
};

export { generatePresignedUrl, uploadToS3 };
